import { render, staticRenderFns } from "./kbjihua.vue?vue&type=template&id=c78c547c&scoped=true"
import script from "./kbjihua.vue?vue&type=script&lang=js"
export * from "./kbjihua.vue?vue&type=script&lang=js"
import style0 from "./kbjihua.vue?vue&type=style&index=0&id=c78c547c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78c547c",
  null
  
)

export default component.exports